import { cn } from '@core/utils';

import { CustomLink } from '@/app/_components/CustomLink';
import { Image } from '@/components/client';
import { ROUTES } from '@/constants';
import { gtmDatasets } from '@/utils/analytics/gtm';

interface GoodsCardProps {
  brandImage?: string;
  thumbnailImage?: string;
  title: string;
  className?: string;
  idx: string;
  price: number;
  replace?: boolean;
  brandName?: string;
}

export const GoodsCard = ({
  brandImage,
  thumbnailImage = '',
  title,
  className,
  idx,
  price,
  replace,
  brandName,
}: GoodsCardProps) => {
  return (
    <CustomLink
      href={ROUTES.POINT_MARKET_DETAIL.pathname({
        idx,
      })}
      replace={replace}
      className={cn('flex h-238 w-160 flex-col ', className)}
      {...gtmDatasets.selectPoint({
        product_name: title,
        product_brand: brandName ?? '',
        product_value: price,
        product_id: idx,
      })}
    >
      <div>
        <div className="relative aspect-square overflow-hidden rounded-small border border-Gray-300 p-4">
          <Image fill src={thumbnailImage} alt={title} className="object-cover" sizes="160px" />
          <div className="absolute inset-0 z-[1] size-full bg-Gray-black opacity-[4%]" />
          {brandImage ? (
            <div className="absolute bottom-10 left-10 z-[2] size-30 overflow-hidden rounded-pill border border-Gray-300 bg-Gray-white">
              <Image fill src={brandImage} alt={`${title} 브랜드 이미지`} className="object-cover" sizes="30px" />
            </div>
          ) : null}
        </div>
        <h3 className="mb-4 mt-8 line-clamp-2 font-400 !leading-[130%] text-Gray-900 typo-body4">
          {title}
        </h3>
      </div>
      <p className="flex gap-2 font-700 typo-body3">
        <span>{price.toLocaleString()}</span>
        <span className="font-600 text-B-500">P</span>
      </p>
    </CustomLink>
  );
};
